import { t } from 'i18next';
import { toast } from 'react-toastify';
import { errorLogger } from 'utils/config/firebase/logs';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { fadeAnimation } from './messages';
import { AxiosError } from 'axios';

export function showErrorMessages(error: unknown, functionAction = '') {
    let message = '';
    let logMessage = '';
    if (error instanceof AxiosError) {
        const errorData = error?.response?.data;

        if (error?.name === 'AbortError') {
            return console.log('AbortError: Fetch request aborted');
        }

        if (errorData?.detail) {
            if (typeof errorData?.detail === 'object') {
                for (const key in errorData?.detail) {
                    message =
                        message + `${errorData?.detail[key]?.loc} ${errorData?.detail[key].msg} `;
                }
            } else if (typeof errorData?.detail === 'string') {
                message = errorData.detail;
            }

            logMessage = `${error?.message ?? ''},  ${message}`;
        } else if (errorData?.message) {
            message = errorData.message;
            logMessage = `${error?.message ?? ''} ${message}`;
        } else if (error?.message) {
            message = error.message;
        } else {
            message = t('messages.error_default');
        }
    }
    errorLogger.critical(logMessage || message, functionAction);
    toast.error(message, {
        position: 'top-center',
        hideProgressBar: true,
        icon: <ErrorOutlineIcon />,
        transition: fadeAnimation,
    });
}
